module.exports = __webpack_public_path__ + "img/app5.219d0ea5.png";